
<template>
<Loader v-if="loader" />
    <div class="table-container">
      <div class="card">
            <div class="formgrid grid ">
                <div class="field col-6 md:col-3 px-3">
                  <label>Tipo utilizzo</label>
                  <Dropdown v-model="selectedTypeUsed" :options="typesUsed" optionLabel="name" optionValue="value"  placeholder="Seleziona una tipologia" :class="['inputfield w-full',{'p-invalid': validationErrors.typeUsed && submitted }]" />
                  <small class="p-error" v-if="validationErrors.typeUsed && submitted">Il campo è richiesto</small>
                </div>
                <div class="field col-6 md:col-3 px-3">
                  <label>Tipo ricerca</label>
                  <Dropdown v-model="selectedTypeSearch" :options="typesSearch" optionLabel="name" optionValue="value"  placeholder="Seleziona una tipologia" :class="['inputfield w-full',{'p-invalid': validationErrors.typeSearch && submitted }]" />
                  <small class="p-error" v-if="validationErrors.typeSearch && submitted">Il campo è richiesto</small>
                </div>
                <div class="field col-6 md:col-3 px-3">
                    <label>Periodo</label>
                    <Calendar v-model="period" class="inputfield w-full" :showIcon="true" dateFormat="dd-mm-yy" selectionMode="range" />
                    <small class="text-400">Lasciare vuoto per tutte le date </small>
                </div>
                <div class="field col-6 md:col-2 px-3">
                    <label>Percentuale sospetta &lt; &gt; {{percentage}} % <br>
                      <small>rispetto alla media</small>
                    </label> <br>
                    <Slider v-model="percentage" :step="1" :min="0" :max="1000" />
                </div>
                 <div class="field col-12 md:col-1 flex align-items-end flex-column px-3">
                    <label> &nbsp;</label>
                    <Button label="" icon="pi pi-search" iconPos="center" class="" @click="searchData" />
                </div>
                <!-- <div class="field col-12 align-items-end">                
                    <p v-if="searchActive" class="p-error" @click="resetFilter">Rimuovi filtri</p>             
                </div> -->
            </div>
        </div>
        <div class="card">

          <DataTable :value="items" v-model:expandedRows="expandedRows"  @rowExpand="onRowExpand" dataKey="id" responsiveLayout="scroll" :filters="filters"
          :paginator="true" :rows="20" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10,20,50]" currentPageReportTemplate="{first} a {last} di {totalRecords}">
            <template #header>
                <div class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                    </span>
                </div>
            </template>
            <Column :expander="true" headerStyle="width: 3rem" />
            <Column field="code_pod" header="Pod" sortable></Column>
            <Column field="month_suspicious" header="Mesi sospetti">
              <template #body="{data}">
                <div v-if="data['month_suspicious'].length > 0">
                  {{data['month_suspicious'].join(' | ')}}
                </div>
              </template>
            </Column>
            <Column field="min" header="Minimo" sortable>
              <template #body="{data}">
                {{data.min.toFixed(2)}}
              </template>
            </Column>
            <Column field="avg" header="Medio" sortable>
              <template #body="{data}">
                {{data.avg.toFixed(2)}}
              </template>
            </Column>
            <Column field="max" header="Massimo" sortable>
              <template #body="{data}">
                {{data.max.toFixed(2)}}
              </template>
            </Column>
            <Column field="tot" header="Totale" sortable>
              <template #body="{data}">
                {{data.qta.toFixed(2)}}
              </template>
            </Column>

            <template #expansion="slotProps">
              <div class="subtable">
                <div class="flex justify-content-center">
                  <div class="col-12 md:col-8">
                    <div class="card">
                      <div v-if="qta.datasets[0].data.length > 0">
                        <Chart ref="chartRef" type="line" :data="qta" />
                      </div>
                    </div>  
                  </div>
                </div>

                <DataTable :value="slotProps.data.months" responsiveLayout="scroll">
                    <Column field="date" header="Data" sortable>
                      <template #body="{data}">
                        {{formatDate(data.date)}}
                      </template>
                    </Column>
                    <Column field="qta" header="Qta mensile" sortable>
                      <template #body="{data}">
                        {{data.qta.toFixed(2)}}
                      </template>
                    </Column>
                    <Column field="cliente" header="Cliente" sortable></Column>
                    <Column field="rappresentante" header="Rappresentante" sortable></Column>
                    <Column field="reseller" header="Reseller" sortable></Column>
                    <Column field="used" header="Utilizzata" sortable>
                    <template #body="{data}">
                      <span v-if=" data.used">
                        {{'SI'}}
                      </span>
                      <span v-else>
                        {{'NO'}}
                      </span>
                    </template>
                    </Column>
                    <Column field="used_ft" header="Fattura utilizzata" sortable></Column>
                </DataTable>
              </div>
            </template>
        </DataTable>
        </div>                        
    </div>
</template>

<script>
import moment from 'moment'
import { FilterMatchMode } from 'primevue/api';
import Service from '@/services/ask-pratiche/pratiche-service'
import { ref, onMounted, getCurrentInstance  } from 'vue';
import Loader from '@/components/Loader.vue'

export default {
    components: {
      Loader
    },
     setup() {
                
        const loader = ref(false);
        const submitted = ref(false);
        const validationErrors = ref({})
        const items = ref([]);
        const filters = ref({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        });
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        self.$http = self.appContext.config.globalProperties.$http
        const formatDate = self.appContext.config.globalProperties.$formatDate
        const service = new Service(self.$http, self.$eventBus)
        const expandedRows = ref([]);
        const percentage = ref(20);
        const period = ref()
        const selectedTypeUsed = ref(-1)
        const typesUsed = [
          {
          'name' : 'Tutti',
          'value' : -1
          },
          {
          'name' : 'Utilizzati in Fattura',
          'value' : 1
          },
          {
          'name' : 'Non utilizzati in Fattura',
          'value' : 0
          }
        ]
        const selectedTypeSearch = ref()
        const typesSearch = [
          {
          'name' : 'Consumo',
          'value' : 'consumi'
          },
          {
          'name' : 'Potenza',
          'value' : 'potenza'
          },
        ]
        const chartRef = ref(null);
        const qta = ref({
            labels: [],
            datasets: [
                {
                    label: '',
                    data: [],
                    fill: true,
                    borderColor: '#FFA726',
                    tension: .4,
                    backgroundColor: 'rgba(255,167,38,0.2)'
                },           
            ]
        });
       
        onMounted(() => {       
          // getData();      
        })
        const getData = () => {
          loader.value = true;
          let dates = stringDate(period.value)
          service.getControlloConsumi(
            selectedTypeSearch.value, 
            selectedTypeUsed.value, 
            dates, 
            percentage.value
          ).then((res) => {
            items.value = res.items
          }).finally(() => {
              loader.value = false;
          })
        }

        const searchData = () => {
          submitted.value = true
          if (validateForm()) {
            getData()
          }
        }

        const stringDate = (dates) => {
            let period = [];
            if (dates) {
               if (dates[0]) {
                period[0] = moment(dates[0]).format('YYYY-MM-DD');
                period[1] = moment(dates[0]).format('YYYY-MM-DD');
                }
                if (dates[1]) {
                  period[1] = moment(dates[1]).format('YYYY-MM-DD');
                } 
            }        
            return period
        }

        const onRowExpand = (event) => {
          buildGraph(event.data)
        };

        const buildGraph = (data) => {

          qta.value.datasets[0].label = selectedTypeSearch.value
          qta.value.labels = []
          qta.value.datasets[0].data = []

          data.months.sort(function(a,b){
            var c = new Date(a.date);
            var d = new Date(b.date);
            return c-d;
          });

          let tot = []
          data.months.forEach(el => {
            qta.value.labels.push(moment(new Date(el.date)).locale('it').format('MMM YYYY').toUpperCase())
            tot.push(el.qta)
          });

          qta.value.datasets[0].data = tot 

        };


        const validateForm = () => {
 
            if (selectedTypeSearch.value)
                delete validationErrors.value['typeSearch'];
            else 
                validationErrors.value['typeSearch'] = true;

            // if (period.value)
            //     delete validationErrors.value['period'];
            // else 
            //     validationErrors.value['period'] = true;

     
            return !Object.keys(validationErrors.value).length;
        }

        
        return { 
          items,
          submitted,
          validationErrors,
          loader,
          filters,
          period,
          typesUsed,
          selectedTypeUsed,
          selectedTypeSearch,
          typesSearch,
          searchData,
          expandedRows,
          onRowExpand,
          percentage,
          chartRef,
          qta,
          formatDate
         }
    }
}
</script>
